import { createSlice } from "@reduxjs/toolkit";

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    case_details: [],
    monthly_earnings: [],
    most_returned_products: [],
    missing_dimensions: [],
    missing_documents: [],
  },
  reducers: {
    setDashboard: (state, action) => {
      state.case_details = action.payload["case_details"];
      state.monthly_earnings = action.payload["monthly_earnings"];
      state.most_returned_products = action.payload["most_returned_products"];
      state.missing_dimensions = action.payload["missing_dimensions"];
      state.missing_documents = action.payload["missing_documents"];
    },
  },
});
export const { setDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
